import { Box, Flex } from "rebass/styled-components";
import styled from "styled-components";

import { ThumbnailRow } from "../../Components/ThumbnailRow";
import { LoadingSkeleton } from "MVVM/Components/Skeloton";
import { PlaylistClips, PlaylistClip } from "../../@types";

export const Thumbnails = ({
  clipsToDisplay,
  renderLolPlaylist = false,
  onWatchLimitReached,
  className,
  platform,
}: {
  clipsToDisplay: PlaylistClips | null;
  renderLolPlaylist?: boolean;
  onWatchLimitReached?: (playerName: string, clickedClip: PlaylistClip) => void;
  platform?: string;
  className?: string;
}) => {
  if (clipsToDisplay && clipsToDisplay?.length > 0) {
    return (
      <ThumbnailWrapper>
        <ThumbnailRow
          thumbnails={clipsToDisplay}
          renderLolPlaylist={renderLolPlaylist}
          onWatchLimitReached={onWatchLimitReached}
          className={className}
          platform={platform}
        />
      </ThumbnailWrapper>
    );
  }

  return (
    <ThumbnailRowSkeleton className={className}>
      <Flex style={{ gap: "10px" }} flexWrap="nowrap" overflowX="scroll">
        {Array.from({ length: 15 }, (_, i) => (
          <ResponsiveThumbnailLoadingSkeleton key={i}>
            <LoadingSkeleton
              width="100%"
              height="100%"
              style={{
                borderRadius: "4px",
                flexShrink: 0,
                boxShadow: "0px 0px 8px 0px rgba(0, 0, 0, 0.4)",
              }}
            />
          </ResponsiveThumbnailLoadingSkeleton>
        ))}
      </Flex>
    </ThumbnailRowSkeleton>
  );
};

const ResponsiveThumbnailLoadingSkeleton = styled(Box)`
  flex-shrink: 0;
  height: 72px;
  width: 128px;

  @media (max-width: 502px) {
    height: 70px;
    width: 124px;
  }
  @media (max-width: 360px) {
    height: 28px;
    width: 50px;
  }
`;

const ThumbnailRowSkeleton = styled(Box)`
  padding: 8px 0;
`;

const ThumbnailWrapper = styled(Flex)`
  flex: 1;
  min-height: 0;
`;
